import React from 'react';
import { Field } from 'redux-form';

import CodeMirrorField from '../../../Common/Utils/CodeMirrorField';
import CodeMirrorInput from '../../../Common/Utils/CodeMirrorInput';

import isBlank from '../../../Common/Utils/Blank';
import isPresent from '../../../Common/Utils/Present';

type Props = {
  attribute_name: string,
  index: number,
  jscode: string,
  prefix?: string // update: not used, but should
};

const CodeMirrorViewer = (props: Props) => (
  <div style={{ maxWidth: 750 }}>
    {isBlank(props.jscode) && <Field
      name={`ad_units[${props.index}].${props.attribute_name}_custom`}
      component={CodeMirrorInput}
      placeholder="function(divID) {\n}"
      label="JS Code"
      mode="javascript" />}
    {isPresent(props.jscode) && <CodeMirrorField value={props.jscode} label="JS Code" />}
  </div>
);

export default CodeMirrorViewer;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Helpers/CodeMirrorViewer.tsx